import { SCREENING_SORT_STRATEGY, StrategyValues } from '../constants/enums';

import { PromptSubTypes } from '../constants/enums';

export const isANewTestgroup = (createdAt) => {
  const today = new Date();
  const testDate = new Date(createdAt);
  const diffTime = Math.abs(today - testDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays <= 60;
};

export const doesNotHaveNewTag = (tags) =>
  !tags?.some((tag) => tag.type === 'MARKETING' && tag.displayName === 'Nuevo');

/**
 * Checks if the given test group uses the AI interview screening strategy.
 *
 * @param {any} testGroup - The test group object to check.
 * @returns {boolean} - True if the strategy is AI_INTERVIEW, otherwise false.
 */
export const isAiInterviewStrategyTestGroup = (testGroup) =>
  testGroup?.screeningSortStrategy === SCREENING_SORT_STRATEGY.AI_INTERVIEW;

/**
 * Checks if the provided strategy is AI_INTERVIEW.
 *
 * @param {string} strategy - The strategy value to check.
 * @returns {boolean} - True if the strategy is AI_INTERVIEW, otherwise false.
 */
export const isAiInterviewStrategy = (strategy) =>
  strategy === SCREENING_SORT_STRATEGY.AI_INTERVIEW;

/**
 * Checks if the provided strategy is 'NORMAL'.
 *
 * @param {string} strategy - The strategy value to check.
 * @returns {boolean} - True if the strategy is 'NORMAL', otherwise false.
 */
export const isNormalStrategy = (strategy) => strategy === StrategyValues.NORMAL;

/**
 * Returns the appropriate strategy value for a custom test group.
 * Defaults to 'NORMAL' if the strategy is not AI_INTERVIEW.
 *
 * @param {string} strategy - The strategy to evaluate.
 * @returns {string} - AI_INTERVIEW if matched, otherwise 'NORMAL'.
 */
export const getCustomTestGroupScreeningStrategy = (strategy) =>
  strategy === SCREENING_SORT_STRATEGY.AI_INTERVIEW
    ? SCREENING_SORT_STRATEGY.AI_INTERVIEW
    : StrategyValues.NORMAL;

/**
 * Returns the screening sort strategy to be saved in testgroup collection if it's AI_INTERVIEW, otherwise returns undefined.
 *
 * @param {string} strategy - The strategy to evaluate.
 * @returns {string | undefined} - AI_INTERVIEW if matched, otherwise undefined.
 */
export const getTestGroupScreeningStrategy = (strategy) =>
  strategy === SCREENING_SORT_STRATEGY.AI_INTERVIEW
    ? SCREENING_SORT_STRATEGY.AI_INTERVIEW
    : undefined;

export const isSFIATestGroup = (testGroup) =>
  testGroup?.tests?.every(
    (test) => (test?.promptSubType ?? test?.test?.promptSubType) === PromptSubTypes.SFIA_CORRECTION
  );

export const someSFIATestGroup = (testGroups) =>
  testGroups?.some((testgroup) => isSFIATestGroup(testgroup));

export const allSFIATestGroups = (testGroups) =>
  testGroups?.length > 0 && testGroups?.every((testgroup) => isSFIATestGroup(testgroup));
